var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 20 } },
    [
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c(
            "el-card",
            {
              staticClass: "emitidos card-totais box-card",
              attrs: { shadow: "always" }
            },
            [
              _c("div", { staticClass: "flex" }, [
                _vm.valorTotalDaeEmitidos !== "0"
                  ? _c("div", [
                      _c("p", { staticClass: "valor" }, [
                        _vm._v("R$ " + _vm._s(_vm.valorTotalDaeEmitidos))
                      ]),
                      _c("p", { staticClass: "descricao" }, [
                        _vm._v("Valor total de DAEs emitidos")
                      ])
                    ])
                  : _c("div", [
                      _c("p", [_vm._v("Não há DAEs emitido nesse período")])
                    ])
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c(
            "el-card",
            {
              staticClass: "card-totais recebidos box-card",
              attrs: { shadow: "always" }
            },
            [
              _c("div", { staticClass: "flex" }, [
                _vm.valorTotalDaeRecebidos
                  ? _c("div", [
                      _c("p", { staticClass: "valor" }, [
                        _vm._v("R$ " + _vm._s(_vm.valorTotalDaeRecebidos))
                      ]),
                      _c("p", { staticClass: "descricao" }, [
                        _vm._v("Valor total de DAEs recebidos")
                      ])
                    ])
                  : _c("div", [
                      _c("p", [_vm._v("Não há DAE recebido nesse período")])
                    ])
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c(
            "el-card",
            {
              staticClass: "card-totais aguardandoPagamento box-card",
              attrs: { shadow: "always" }
            },
            [
              _c("div", { staticClass: "flex" }, [
                _vm.valorTotalDaeAguardandoPagamento
                  ? _c("div", [
                      _c("p", { staticClass: "valor" }, [
                        _vm._v(
                          "R$ " + _vm._s(_vm.valorTotalDaeAguardandoPagamento)
                        )
                      ]),
                      _c("p", { staticClass: "descricao" }, [
                        _vm._v("Valor total de DAEs aguardando pagamento")
                      ])
                    ])
                  : _c("div", [
                      _c("p", [
                        _vm._v("Não há DAE aguardando pagamento nesse período")
                      ])
                    ])
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [
          _c(
            "el-card",
            {
              staticClass: "card-totais vencido box-card",
              attrs: { shadow: "always" }
            },
            [
              _c("div", { staticClass: "flex" }, [
                _vm.valorTotalDaeVencido
                  ? _c("div", [
                      _c("p", { staticClass: "valor" }, [
                        _vm._v("R$ " + _vm._s(_vm.valorTotalDaeVencido))
                      ]),
                      _c("p", { staticClass: "descricao" }, [
                        _vm._v("Valor total de DAEs vencidos")
                      ])
                    ])
                  : _c("div", [
                      _c("p", [_vm._v("Não há DAE vencido nesse período")])
                    ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9202990", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9202990","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/relatoriosDae/components/DaeTotais.vue
// module id = null
// module chunks = 